import { combine, createEffect, createStore } from "effector"
import WorkingDaysCalendar from "models/WorkingDaysCalendar"

import WorkingDaysCalendars from "models/WorkingDaysCalendars"
import AssetService from "services/AssetService"
import { Guid } from "@/types"

export const $workingDaysCalendars = createStore<WorkingDaysCalendars | null>(null)

export const fetchWorkingDaysCalendars = createEffect(() => {
    return AssetService.getWorkingDaysCalendars()
})

export const $isFetchWorkingDaysCalendars = combine([
    fetchWorkingDaysCalendars.inFlight,
], ([count]) => count > 0)

export const $workingDaysCalendarsMap = combine([
    $workingDaysCalendars,
], ([workingDaysCalendars]) => {
    const map = new Map<Guid, WorkingDaysCalendar>()
    workingDaysCalendars?.items?.forEach(wDC => {
        map.set(wDC.id, wDC)
    })
    return map
})

$workingDaysCalendars.on(fetchWorkingDaysCalendars.doneData, (_, payload) => payload)
